// Generated from ContestStepScore's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestStepScoreCollectionFilterGroups
  = | {
    readonly participant: Iri
  }
  | {
    readonly step: Iri
    readonly participantCategory?: Iri | Iri[]
  }

export const contestStepScoreCollectionFilterMapping: FilterDefinitionMapping<ContestStepScoreCollectionFilterGroups> = {
  participant: 'participant',
  step: 'step',
  participantCategory: 'participant.category',
}

export type ContestStepScoreCollectionSort = never
